import React from 'react';

import { DropdownItem } from '@weezevent/nacre';
import DeleteAction from './../actions/deleteAction';
import DeleteActionAttendee from './../../../pages/attendee/actions/deleteAction';
import useAppContext from '../../../context/useAppContext';
import Auth from '../../../utils/auth';
import { useTranslation } from 'react-i18next';
import { usePermissions } from '../../../user/permissions';
import AnonymizeAction from '../actions/anonymizeAction';
import { useSegment } from '../../../components/tracking/trackingProvider';
import DeleteRefundRequestAction from './../actions/deleteRefundRequestAction';
import DeleteRefundRequestActionAttendee from './../../../pages/attendee/actions/deleteRefundRequestAction';
import { capitalizeFirstLetter } from '../../attendee/detail/components/utils';

export function ActionDropdownItem({ label = null, modelAction = null, onChangeAction = () => {}, items = [], mode = 'list', type = 'unique', isEmailingBlocked }) {
    const [{ event, feature_flags, organization }] = useAppContext();
    const { track } = useSegment();
    const permissions = usePermissions();
    const { t } = useTranslation();

    const trackingActionValues = React.useMemo(() => {
        return {
            name: modelAction.NAME.split('_')
                .join(' ')
                .toUpperCase(),
            origin: modelAction.TYPE.toUpperCase(),
            type: capitalizeFirstLetter(type)
        };
    }, [modelAction, capitalizeFirstLetter, type]);

    const onSubmitAction = React.useCallback(() => {
        onChangeAction({ action: modelAction, items });
        if (mode === 'detail' && type === 'unique' && ['ATTENDEES', 'ORDERS'].includes(trackingActionValues.origin)) {
            track(`ACTION > ${trackingActionValues.name}`, {
                'Page Title': trackingActionValues.origin === 'ATTENDEES' ? 'ATTENDEE PROFILE' : 'ORDER DETAILS'
            });
        } else track(`ACTION > ${trackingActionValues.name}`, { 'Page Title': `MANAGE ${trackingActionValues.origin}`, 'Action type': trackingActionValues.type });
    }, [onChangeAction, track, trackingActionValues, items, modelAction]);

    if (!modelAction || !modelAction.is_available({ event, feature_flags, items, mode, permissions, organization })) {
        return null;
    }

    return (
        <Auth allow={modelAction.CAPACITIES}>
            {(modelAction.NAME === DeleteAction.NAME || modelAction.NAME === DeleteActionAttendee.NAME) && <DropdownItem.Line />}
            <DropdownItem
                disabled={modelAction.is_disabled({ items, event }) || (isEmailingBlocked && modelAction.SENDS_EMAILS)}
                item={label || t('ticket.manager.' + modelAction.TYPE + '.action.' + modelAction.NAME + '.dropdownItem', { count: items.length })}
                deleteItem={[DeleteAction.NAME, DeleteActionAttendee.NAME, AnonymizeAction.NAME, DeleteRefundRequestActionAttendee.NAME, DeleteRefundRequestAction.NAME].includes(
                    modelAction.NAME
                )}
                onClick={onSubmitAction}
            />
        </Auth>
    );
}
